module.exports = __webpack_public_path__ + "static/assets/2c76298568c6e145c9f32d4de336a106.png";